import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { COMMON_LOADING_STATES } from "../../../constants/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ResubmitDataService from "../../../../../services/ResubmitDataService";
import { componentKey, setLoadingState, setPayersList, setSelectedPayer, setSelectedTaxYear, setTaxYearList, setSelectedForm, setFormList, setRejected1099FormsGrid, setDeleteRejectedFormModal, setClickedFormDetails, setPayerListLoadingState, setGridDataLoadingState, setPaginationState } from "./Form1099Slice";
import FormsDataService from "../../../../../services/FormsDataService";
import General from "../../../../../libs/utility/General";
import RightsManagementDataService from "../../../../../services/RightsManagementDataService";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { REVIEW_REJECTED_LOADING_STATES } from "../constants";

export const { getFormsList, getTaxYears, getPayersBySelectedForm, getRejectedFormsGridData, deleteRejectedForm, viewRejectedFormPDF, resubmitRejectedForm } = {

    getFormsList: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/FORM_1099/GET_FORMS",
            payload
        }
    },

    getTaxYears: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/FORM_1099/GET_TAX_YEARS",
            payload
        }
    },

    getPayersBySelectedForm: (payload) => {
        return {
            type: "REVIEW_REJECTED_FORMS/FORM_1099/GET_PAYERS",
            payload
        }
    },

    getRejectedFormsGridData: (payload) => {
        return {
            type: "REJECTED_FORMS/GET_GRID_DATA",
            payload
        }
    },

    deleteRejectedForm: (payload) => {
        return {
            type: "REJECTED_FORMS/DELETE_REJECTED_FORM",
            payload
        }
    },

    viewRejectedFormPDF: (payload) => {
        return {
            type: "REJECTED_FORMS/VIEW_PDF",
            payload
        }
    },

    resubmitRejectedForm: (payload) => {
        return {
            type: "REJECTED_FORMS/RESUBMIT_FORM",
            payload
        }
    }

}

function* getFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_LOADING }));

        const { formId } = action.payload;

        const response = yield FormsDataService.getFormsList();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const formList = [...Data.Forms];
            General.addOptionAndValueKeys(formList, "FormLabel", "Id")

            yield put(setFormList(formList));

            if (formId) {
                const form = formList.find(form => form.Id == formId);
                if (form) {
                    yield put(setSelectedForm(form))
                }
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch forms list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch forms list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_READY }))
    }
}

function* getTaxYearsAsync(action) {

    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.TAXYEARS_LIST_LOADING }));

        const { formId, taxYear } = action?.payload;

        const response = yield FormsDataService.getCascadeTaxYears(formId);

        const { Message, Status, Data } = response?.data;

        if (Status) {

            const yearsList = Data.map(year => {
                return { ...year, label: year.ID, value: year.ID, itemName: year.ID }
            })

            yield put(setTaxYearList(yearsList));

            if (taxYear) {
                const year = yearsList.find(year => year.value == taxYear);
                if (year) {
                    yield put(setSelectedTaxYear(year));
                }
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch tax years", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch tax years", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.TAXYEARS_LIST_READY }))
    }

}

function* getPayersBySelectedFormAsync(action) {
    try {
        yield put(setPayerListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_LOADING }));

        const { formId, payerId, taxYear, paginationState } = action.payload;

        const params = { formId }
        const response = yield RightsManagementDataService.reviewAndApprovePayers(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const payersList = [...Data];
            General.addOptionAndValueKeys(payersList, "LastName", "PayerDetailId");

            yield put(setPayersList(payersList));

            if (payerId) {
                const payer = payersList.find(payer => payer.value == payerId);

                if (payer) {
                    yield put(setSelectedPayer(payer));
                }

                if (payer && formId && taxYear) {
                    yield put(getRejectedFormsGridData({
                        formId,
                        payerId,
                        taxYear,
                        ...paginationState,
                    }))
                }
            }

        } else {
            yield put(addNotifications({ heading: "Failed to fetch payers", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch payers", message: error?.response?.data?.Message }));
        yield put(setPayerListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_READY }))
    } finally {
        yield put(setPayerListLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_READY }))
    }
}

function* getRejectedFormsGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING }))

        const { formId, payerId, taxYear, PageNumber, PageSize, FilterText, IdNumber, IsDesc } = action.payload

        const params = {
            formId,
            payerId,
            taxYear,
            PageNumber,
            PageSize,
            FilterText: "",
            IdNumber: "",
            IsDesc: false,
        }

        const response = yield RightsManagementDataService.reviewRejectedGridData(params);

        const { Message, Status} = response?.data;
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setRejected1099FormsGrid(Data));
            yield put(setPaginationState({ total: General.extractPaginationTotalFromResponse(response.data) }));
        } else {
            yield put(addNotifications({ heading: "Failed to get the grid data", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get the grid data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* deleteRejectedFormAsync(action) {

    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_LOADING }))

        const { formSubmissionId, formId, payerId, taxYear, paginationState } = action.payload;

        const response = yield SubmitFormsDataService.deleteSingleForm({ formSubmissionId, formId });

        const { Message, Status } = response?.data;

        if (Status) {
            yield put(setDeleteRejectedFormModal(false))
            yield put(getRejectedFormsGridData({ formId, payerId, taxYear, ...paginationState }));
            yield put(setClickedFormDetails({}))
            yield put(addNotifications({ heading: "Form successfully deleted!", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(setDeleteRejectedFormModal(false))
            yield put(addNotifications({ heading: "Failed to delete a form", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setDeleteRejectedFormModal(false))
        yield put(setClickedFormDetails({}))
        yield put(addNotifications({ heading: "Failed to delete a form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_READY }))
    }
}

function* viewRejectedFormPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.REVIEW_REJECTED_PAGE_LOADING }))

        const { formId, payerId, formTypeId } = action.payload

        const data = {
            formId,
            PayerId: payerId,
            formTypeId: formTypeId,
            isUnMask: false,
            employerId: 0
        }

        const response = yield SubmitFormsDataService.downloadSinglePDF(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to open the PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.REVIEW_REJECTED_PAGE_READY }))
    }
}

function* resubmitRejectedFormAsync(action) {
    try {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_LOADING }));

        const { formIds, payerId, formName, payerName, taxyear, remarks, paginationState, formId } = action.payload;

        const params = {
            formIds,
            payerId,
            formName,
            payerName,
            taxyear,
            remarks
        };

        const response = yield RightsManagementDataService.resubmitRejectedForms(params);

        const { Status, Message, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Form(s) Resubmitted Successfully", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(getRejectedFormsGridData({ formId, payerId, taxYear: taxyear, ...paginationState }));
        } else {
            yield put(addNotifications({ heading: "Failed to resubmit the form", message: Message }));
        }

    }
    catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to resubmit the form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFormsList().type, getFormsListAsync),
        takeLatest(getTaxYears().type, getTaxYearsAsync),
        takeLatest(getPayersBySelectedForm().type, getPayersBySelectedFormAsync),
        takeLatest(getRejectedFormsGridData().type, getRejectedFormsGridDataAsync),
        takeLatest(deleteRejectedForm().type, deleteRejectedFormAsync),
        takeLatest(viewRejectedFormPDF().type, viewRejectedFormPDFAsync),
        takeLatest(resubmitRejectedForm().type, resubmitRejectedFormAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);